import router from '@/router'
import { tidio as tidioConfig } from '@/config/site'

const publicKey = process.env.VUE_APP_TIDIO_PUBLIC_KEY?.trim()

let scriptInjected = false

function shouldHideOnRoute(path) {
  return tidioConfig.hideOnRoutes?.includes(path) ?? false
}

function applyRouteVisibility() {
  const api = window.tidioChatApi
  if (!api || typeof api.display !== 'function') return

  api.display(!shouldHideOnRoute(router.currentRoute.value.path))
}

function onTidioReady() {
  applyRouteVisibility()
}

/**
 * Loads the Tidio chat widget when VUE_APP_TIDIO_PUBLIC_KEY is set.
 * Get your key: Tidio panel → Settings → Developer → Public key
 */
export function initTidio() {
  if (!publicKey || scriptInjected) return

  scriptInjected = true

  window.tidioChatApi = window.tidioChatApi || function tidioQueue(...args) {
    window.tidioChatApi.q = window.tidioChatApi.q || []
    window.tidioChatApi.q.push(args)
  }

  document.addEventListener('tidioChat-ready', onTidioReady)

  router.afterEach(() => {
    applyRouteVisibility()
  })

  const script = document.createElement('script')
  script.src = `https://code.tidio.co/${publicKey}.js`
  script.async = true
  document.head.appendChild(script)
}
